<template>
  <div class="add-account-container">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <p class="title">请输入需要订阅的公众号名称或准确微信号</p>
        <div class="control is-horizontal">
          <input type="text" class="input-text" placeholder="搜索公众号" v-model='searchKey'>
          <button class="button is-primary" @click="searchClick">搜索</button>
        </div>
        <label class="label">如果搜索不到,你还可以换一种方式,直接订阅</label>
        <div class="control is-horizontal">
          <input type="text" class="input-text-w200" placeholder="输入公众号ID" v-model="accountNumber">
          <input type="text" class="input-text-w200" placeholder="输入公众号名称" v-model="accountName" style="margin:0 10px;">
          <button class="button is-primary" @click="subscribeClick">订阅</button>
        </div>
      </article>
    </div>
    <div class="tile is-parent">
      <article class="tile is-child box">
          <div class="account-list-wrap">
            <div v-if="accountList.length == 0">
              <p class="tips">请输入公众号名称或者准确微信号,进行搜索</p>
            </div>
            <template v-else="">
              <div v-if="count > 0" class="clearfix">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="count"
                  class="fright">
                </el-pagination>
              </div>
              <div class="account-list" v-for="(item,key) in accountList">
                <div class='account-link'>
                  <div class="info">
                    <p class="name">{{item.accountName}} <span class="account-number">【微信号:{{item.accountNumber}}】</span></p>
                    <p>{{item.description}}</p>
                  </div>
                </div>
                <button v-if='item.categoryList' class="subscribe-btn button is-warning" @click="onShowModel(key,item,'cancel')">已订阅</button>
                <div v-if='item.categoryList' class='category-list'>
                  <span class='category' v-for="value in item.categoryList">
                    {{value}}
                  </span>
                </div>
                <button v-if='!item.categoryList' class="subscribe-btn button is-success " @click="onShowModel(key,item,'subscribe')">订阅</button>
              </div>
              <div v-if="count > 0" class="clearfix">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="count"
                  class="fright">
                </el-pagination>
              </div>
            </template>
          </div>
      </article>
    </div>
    <category-modal ref="categoryModalRef" :item="modal.item" :item-categorylist='modal.itemCategorylist' @update-category-event="updateCategoryEvent"></category-modal>
  </div>
</template>
<script type="text/babel">
  import CategoryModal from '../common/categoryModal/categoryModal';
  import Vue from 'vue';

  export default {
    components:{
      CategoryModal
    },
    data(){
      return {
        accountList:[],
        searchKey: '',
        currentIndex: 0,
        currentPage:1,
        count:1,
        pageSize:20,
        modal:{
          visible:false,
          item: {},//这里是添加,categoryList为空
          name:"",
          itemCategorylist: []
        },
        accountName:"",
        accountNumber:""
      }
    },

    methods: {
      //分页更新
      handleCurrentChange(value) {
        if(this.currentPage !== value){
          this.currentPage = value;
          this.searchClick();
        }
      },
      //更新分类
      updateCategoryEvent(data){
        let categoryList = []
        _.each(data, (item)=> {
          categoryList.push(item.categoryName)
        })
        Vue.set(this.accountList[this.currentIndex], 'categoryList', categoryList);
      },
      //搜索
      searchClick() {
        if(!this.searchKey){
          this.$message("请输入要搜索的公众号名称或微信号");
          return false
        }
        let params = {
          keyword:this.searchKey,
          page:this.currentPage,
          pageSize:this.pageSize
        }
        HttpRequest.post('/admin.php?method=wechat.search', params,true).then((response) => {
          this.accountList = response.data.list;
          this.count = response.data.pageInfo.count;
        })
      },
      onShowModel(key, item,type){
        if(type == "cancel"){//取消类型
          let params = {
            type:0,
            accountName:item.accountName,
            accountNumber:item.accountNumber,
            categoryIds:[0]
          }
          HttpRequest.post('/admin.php?method=wechat.subscribe', params, true).then((response) => {
            this.accountList[this.currentIndex].categoryList = null
          })
        }else if(type == "subscribe"){
          this.currentIndex = key;
          this.modal.item = item
          this.$refs.categoryModalRef && this.$refs.categoryModalRef.showModal()
        }
      },
      //直接订阅
      subscribeClick(){
        if(!this.accountNumber){
          this.$message("请输微信号!")
          return false
        }
        if(!this.accountName){
          this.$message("请输微信名!")
          return false
        }
        let params = {
          type:1,
          accountNumber:this.accountNumber,
          accountName:this.accountName
        }
        HttpRequest.post('/admin.php?method=wechat.subscribe', params,true).then((response) => {
          if(response.data.success == true){
            this.accountNumber = "";
            this.accountName = "";
            this.$message("订阅成功!")
          }
        })
      }
    }
  }
</script>
<style lang="less">
  .add-account-container{
    .tips{
      width: 400px;
      margin: 40px auto;
      text-align: center;
    }
    .input-text{
      margin-right: 10px;
      width: 400px;
    }
    .input-text-w200{
      width: 200px;
    }
    .account-list-wrap{
        min-height: 400px;
      .account-list{
        margin:30px;
        display: flex;

        .account-link {
            display: flex;
            flex: 1;
            .info {
              flex: 1;
            }
        }
        .category-list {
          height: 32px;
          line-height: 32px;
          position: relative;
          top: 16px;
          margin-left: 10px;

          .category {
              background: #eaeaea;
              padding: 5px 10px;
              color: #333;
              margin-right: 8px;
          }
        }
        .info{
          .name{
            font-size: 20px;
            color: #333;
            font-weight: 500;
            margin-bottom: 10px;
            .account-number{
              font-size: 14px;
              color: #42afe3;
            }
          }
        }
        .subscribe-btn{
          position: relative;
          top: 16px;
        }
      }
    }
  }
</style>
